import { __assign } from "tslib";
/* eslint-disable no-console */
import { isSSR } from 'wix-rich-content-common';
var baseDecodedInstance = {
    instanceId: '',
    appDefId: '',
    metaSiteId: '',
    uid: '',
    siteOwnerId: '',
};
function splitInstance(instance) {
    console.assert(instance, 'instance is mandatory');
    var splitted = instance.split('.');
    console.assert(splitted.length >= 2, 'instance must contain data and signature separated by .');
    var _a = splitted.slice(-2), signature = _a[0], data = _a[1];
    return { data: data, signature: signature };
}
export function parseInstance(instance) {
    if (!instance) {
        return baseDecodedInstance;
    }
    var data = splitInstance(instance).data;
    var bit64Data = isSSR()
        ? // Accessing 'Buffer' via 'global' prevents webpack polyfilling it for web environment
            global.Buffer.from(data, 'base64').toString('utf8')
        : atob(data);
    var decodedInstance = JSON.parse(bit64Data);
    return __assign(__assign({}, baseDecodedInstance), decodedInstance);
}
//# sourceMappingURL=parseInstance.js.map